export default __webpack_public_path__ + "static/logo-3b0eeff3146c1b7c3aa4c5395062a24b.png";